if (!customElements.get('combined-listings')) {
    customElements.define('combined-listings', class CombinedListings extends HTMLElement {
        constructor() {
            super();
            this.isSwapping = false;
            this.selectedSize = null;
        }

        connectedCallback() {
            this.addEventListener('submit', (e) => e.preventDefault(), true);
            this.addEventListener('change', this.handleChange.bind(this));

            document.addEventListener('change', (e) => {
                if (e.target.name?.toLowerCase().includes('size')) {
                    this.selectedSize = e.target.value;
                }
            });

            this.initFromUrl();
        }

        handleChange(e) {
            if (e.target.name === 'combined-listing-product') {
                this.swapProduct(e.target.dataset.productUrl);
            } else if (e.target.name?.toLowerCase().includes('size')) {
                this.selectedSize = e.target.value;
            }
        }

        getSelectedSize() {
            if (this.selectedSize) return this.selectedSize;

            const sizeInput = document.querySelector('input[name*="size" i]:checked');
            if (sizeInput) {
                this.selectedSize = sizeInput.value;
                return sizeInput.value;
            }

            const sizeSelect = document.querySelector('select[name*="size" i]');
            if (sizeSelect?.selectedIndex >= 0) {
                const value = sizeSelect.options[sizeSelect.selectedIndex]?.text || sizeSelect.value;
                this.selectedSize = value;
                return value;
            }

            return null;
        }

        buildUrl(baseUrl) {
            const size = this.getSelectedSize();
            if (!size) return baseUrl;

            const separator = baseUrl.includes('?') ? '&' : '?';
            return `${baseUrl}${separator}size=${encodeURIComponent(size)}`;
        }

        async swapProduct(url) {
            if (this.isSwapping || !url) return;

            const productInfo = document.querySelector('product-info[data-update-url="true"]');
            if (!productInfo) return;

            this.isSwapping = true;

            const productInfoWrapper = document.querySelector('.product__info-wrapper');
            if (productInfoWrapper) {
                productInfoWrapper.classList.add('product__info-wrapper--loading');
            }

            const response = await fetch(this.buildUrl(url));
            if (!response.ok) {
                this.isSwapping = false;
                if (productInfoWrapper) {
                    productInfoWrapper.classList.remove('product__info-wrapper--loading');
                }
                return;
            }

            const html = new DOMParser().parseFromString(await response.text(), 'text/html');
            const newMain = html.querySelector('main');
            if (!newMain) {
                this.isSwapping = false;
                if (productInfoWrapper) {
                    productInfoWrapper.classList.remove('product__info-wrapper--loading');
                }
                return;
            }

            HTMLUpdateUtility.viewTransition(
                document.querySelector('main'),
                newMain,
                productInfo.preProcessHtmlCallbacks,
                productInfo.postProcessHtmlCallbacks
            );

            const newBreadcrumbs = html.querySelector('.breadcrumbs__list');
            const currentBreadcrumbs = document.querySelector('.breadcrumbs__list');
            if (newBreadcrumbs && currentBreadcrumbs) {
                currentBreadcrumbs.innerHTML = newBreadcrumbs.innerHTML;
            }


            document.dispatchEvent(new CustomEvent('main-content-updated'));
            this.restoreSizeWithRetry();

            setTimeout(() => {
                const updatedProductInfoWrapper = document.querySelector('.product__info-wrapper');
                if (updatedProductInfoWrapper) {
                    updatedProductInfoWrapper.classList.remove('product__info-wrapper--loading');
                }
                this.isSwapping = false;
            }, 500);
        }

        selectSize(size, silent = false) {
            if (!size) return false;

            const sizeInput = document.querySelector(`input[name*="size" i][value="${size}"]`);
            if (sizeInput) {
                sizeInput.checked = true;
                if (!silent) {
                    sizeInput.dispatchEvent(new Event('change', { bubbles: true }));
                }
                this.selectedSize = size;
                return true;
            }

            const sizeSelect = document.querySelector('select[name*="size" i]');
            if (sizeSelect) {
                const option = Array.from(sizeSelect.options).find(opt =>
                    opt.text === size || opt.value === size
                );
                if (option) {
                    sizeSelect.value = option.value;
                    if (!silent) {
                        sizeSelect.dispatchEvent(new Event('change', { bubbles: true }));
                    }
                    this.selectedSize = size;
                    return true;
                }
            }

            return false;
        }

        restoreSizeWithRetry() {
            const size = this.selectedSize;
            if (!size) return;

            let attempts = 0;
            const maxAttempts = 5;

            const tryRestore = () => {
                const found = this.selectSize(size, true);
                if (found) {
                    this.selectSize(size, false);
                    return;
                }
                if (++attempts >= maxAttempts) return;
                setTimeout(tryRestore, 100);
            };

            setTimeout(tryRestore, 100);
        }

        initFromUrl() {
            const urlSize = new URLSearchParams(window.location.search).get('size');
            if (!urlSize) return;

            this.selectedSize = urlSize;
            this.selectSize(urlSize);
            window.history.replaceState({}, '', window.location.pathname);
        }
    });
}